module.exports = __webpack_public_path__ + "img/calendar.f32bfc62.svg";